import { render, staticRenderFns } from "./ConfirmarPresencaDialog.vue?vue&type=template&id=3bdb76a2&scoped=true"
import script from "./ConfirmarPresencaDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmarPresencaDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmarPresencaDialog.vue?vue&type=style&index=0&id=3bdb76a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdb76a2",
  null
  
)

export default component.exports